import * as React from 'react';
import * as _ from 'lodash';

import InputContainer from 'login-components/Common/Inputs/InputContainer/InputContainer';
import { getIdFromName } from 'login-components/Common/Inputs/inputUtils';
import { constants } from '@blend/ui-common';
const { stateCodes } = constants;

const stateInputValues = [
  {
    text: '—', // this is an emdash, not a hyphen
    value: '',
  } as Workflow.Choice,
].concat(stateCodes.states);

class StateInput extends React.Component<InputProps, {}> {
  render() {
    const { input, meta, label } = this.props;
    return (
      <div className="StateInput">
        <InputContainer
          label={label}
          name={input.name}
          identifier={input.name}
          error={meta.touched && /* istanbul ignore next: (UI-5482) */ meta.error}
        >
          <select {...input} id={getIdFromName(input.name)}>
            {stateInputValues.map(state => (
              <option value={_.toString(state.value)} key={_.toString(state.value)}>
                {state.text}
              </option>
            ))}
          </select>
        </InputContainer>
      </div>
    );
  }
}

export const StateInputConfig = {
  component: StateInput,
};

export default StateInput;
